export enum TabRefId {
    COMMITMENTS = 'commitments',
    OBSERVATIONS = 'observations',
    TRANSCRIPTS = 'transcripts',
}
